import React from 'react';
import { Building2, Copy, Check, ArrowLeft, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { BANK_INFO } from './checkoutText';

export const TransferSection = ({ text, total, processing, onSubmit, onBack }) => {
  const copyClabe = () => { navigator.clipboard.writeText(BANK_INFO.clabe); toast.success(text.copied); };
  return (
    <div className="space-y-4" data-testid="transfer-section">
      <h3 className="font-semibold text-slate-800 flex items-center gap-2">
        <Building2 className="w-4 h-4" /> {text.transferTitle}
      </h3>
      <div className="bg-slate-50 rounded-xl p-4 space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-xs text-slate-500">{text.transferHolder}</span>
          <span className="font-medium text-sm text-slate-800">{BANK_INFO.name}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-xs text-slate-500">{text.transferBank}</span>
          <span className="font-medium text-sm text-slate-800">{BANK_INFO.bank}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-xs text-slate-500">{text.transferClabe}</span>
          <div className="flex items-center gap-2">
            <span className="font-mono font-bold text-sm text-cyan-600">{BANK_INFO.clabe}</span>
            <button onClick={copyClabe} className="text-slate-400 hover:text-cyan-600" data-testid="copy-clabe"><Copy className="w-4 h-4" /></button>
          </div>
        </div>
        <div className="flex justify-between items-center border-t pt-3">
          <span className="text-xs text-slate-500">{text.total}</span>
          <span className="font-bold text-lg text-cyan-600">${total.toFixed(2)} MXN</span>
        </div>
      </div>
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-center">
        <p className="text-sm font-semibold text-amber-800 leading-relaxed">{text.transferNote}</p>
      </div>
      <Button onClick={onSubmit} disabled={processing} className="w-full h-12 bg-green-600 hover:bg-green-700 text-white font-semibold" data-testid="transfer-submit-btn">
        {processing ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />{text.processing}</> : <><Check className="w-4 h-4 mr-2" />{text.transferSubmit}</>}
      </Button>
      <Button variant="ghost" onClick={onBack} className="w-full text-slate-500 text-sm" data-testid="transfer-back-btn">
        <ArrowLeft className="w-4 h-4 mr-1" /> {text.back}
      </Button>
    </div>
  );
};
